import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudCheckboxModule,
	FreudTooltipModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ContactsTableBaselineFilterComponent } from './contacts-table-baseline-filter.component';

@NgModule({
	declarations: [ContactsTableBaselineFilterComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FreudTypographyModule,
		FreudCheckboxModule,
		FreudTooltipModule,
		FormsModule,
	],
	exports: [ContactsTableBaselineFilterComponent],
	providers: [],
})
export class ContactsTableBaselineFilterModule {}
